import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './i18n.js'; // i18n konfigürasyon dosyasını import et
import HomePage from './components/HomePage';
import ServiceDetail from './components/ServiceDetail';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/service/:serviceType" element={<ServiceDetail />} />
      </Routes>
    </Router>
  );
};

export default App;